const userConfirmationActionTypes = {
  RESET_STATE: 'RESET_STATE',
};

export { userConfirmationActionTypes as default };
